// extracted by mini-css-extract-plugin
module.exports = {"root":"TabPanel_root__2zNOw","tabsRoot":"TabPanel_tabsRoot__2L5DB","tabsIndicator":"TabPanel_tabsIndicator__Zs2Wo"};